const initialState = {
  company: {
    urlBrand: null,
    plan: {},
  },
  brandActions: null,
  myMetric: 'nps-0-10',
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/companies/initialState.js